<template>
  <div class="matrix-scroll">
    <div class="flex">
      <div style="flex: 0 0 20vw"></div>
      <div class="flex-1 flex justify-between">
        <span>{{ labels[0].text }}</span>
        <span>{{ labels[1].text }}</span>
      </div>
    </div>
    <div v-for="item in issue.items" :key="item.id">
      <div class="option-title">
        <span class="inline-block" v-html="item.content.richText"></span>
      </div>
      <div class="option-slider">
        <w-slider
          :min="issue.min"
          :max="issue.max"
          :value="item.value"
          @input="onSliderChange($event, item)"
          :show-input="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WSlider from '@/questions/components/WSlider'

export default {
  name: 'MatrixScroll',
  components: { WSlider },
  changeExpr: 'currentValue',
  computed: {
    labels() {
      return this.issue.labels
    },
    currentValue() {
      return this.getCurrentValue()
    }
  },
  methods: {
    getCurrentValue(exclusiveItem) {
      return this.issue.items.reduce((preValue, item) => {
        if (exclusiveItem && exclusiveItem.id === item.id) {
          return preValue + 0
        }
        return preValue + parseInt(item.value)
      }, 0)
    },
    onSliderChange(value, item, index) {
      item.value = value
    }
  }
}
</script>

<style scoped></style>
